import * as Pages from '../../components/pages/pages.index';
import {
  activeMenuItemKey,
  EActiveMenuItem,
} from '../../components/organisms/navigationMenu/navigationItems';

export enum ERoutes {
  SESSION = '/session',
  HOME = '/home',
  LOGIN_ERROR = '/login-error',
  EMAIL_NOT_VERIFIED = '/email-not-verified/:userId',
  WISH_LIST_CATALOGUE = '/wishlist',
  WISH_FINDER = '/wish-finder',
  WISH_LIST = '/wishlist/:wishListId',
  WISH_LIST_PUBLIC = '/wishlist/public/:wishListId',
  GROUP_LIST = '/group',
  GROUP = '/group/:groupId',
  GROUP_IN_PROGRESS_WISH = '/group/:groupId/in-progress/wish',
  GROUP_IN_PROGRESS_MONEYBOX = '/group/:groupId/in-progress/moneybox',
  NEW_GROUP = '/newgroup',
  EDIT_GROUP = '/editgroup/:groupId',
  WISH = '/wishlist/:wishListId/wish/:wishId',
  NEW_WISH = '/wishlist/:wishListId/newwish',
  MY_CONTACT_LIST = '/my-contacts',
  PERSONAL_PAGE = '/personal-page',
  CONTACT_WISH_LIST_CATALOGUE = '/contact/wishlist',
  CONTACT_WISH_LIST = '/contact/wishlist/:wishListId',
  CHAT = '/chat/:groupId',
  MY_BANK = '/my-bank',
  PENDING_PAYMENTS = '/my-bank/pending-payments',
  PAYMENTS_RESUME = '/my-bank/payments-resume',
  SOCIAL_PROJECTS = '/my-bank/social-projects',
  POLICY = '/policy',
  LILI_BANK = '/my-bank/lili-bank',
  TPV_OK = '/payment/confirmed',
  TPV_KO = '/payment/failed',
  ONBOARDING = '/onboarding',
  EXPLORE = '/explore',
  NOT_FOUND = '/not-found',
}

export type TRoutes =
  | ERoutes.SESSION
  | ERoutes.HOME
  | ERoutes.LOGIN_ERROR
  | ERoutes.EMAIL_NOT_VERIFIED
  | ERoutes.WISH_LIST_CATALOGUE
  | ERoutes.WISH_FINDER
  | ERoutes.WISH_LIST
  | ERoutes.WISH_LIST_PUBLIC
  | ERoutes.GROUP_LIST
  | ERoutes.GROUP
  | ERoutes.GROUP_IN_PROGRESS_WISH
  | ERoutes.GROUP_IN_PROGRESS_MONEYBOX
  | ERoutes.NEW_GROUP
  | ERoutes.EDIT_GROUP
  | ERoutes.WISH
  | ERoutes.NEW_WISH
  | ERoutes.MY_CONTACT_LIST
  | ERoutes.PERSONAL_PAGE
  | ERoutes.CONTACT_WISH_LIST_CATALOGUE
  | ERoutes.CONTACT_WISH_LIST
  | ERoutes.CHAT
  | ERoutes.MY_BANK
  | ERoutes.PENDING_PAYMENTS
  | ERoutes.PAYMENTS_RESUME
  | ERoutes.SOCIAL_PROJECTS
  | ERoutes.POLICY
  | ERoutes.LILI_BANK
  | ERoutes.TPV_OK
  | ERoutes.TPV_KO
  | ERoutes.ONBOARDING
  | ERoutes.EXPLORE
  | ERoutes.NOT_FOUND;

/**
 * The file auth.tsx, for some reason beyond my understanding try to log in the user even when the route
 * is not restricted and store the action in the setIsSessionStartPage forcing a call to Auth0. Obviously
 * for my future self or any other developer reading this, not restricted and public should be the same,
 * but for lack of time for re-testing the whole aplication I thought it would better for my present self
 * create a new property
 * */
export const Routes = [
  {
    path: ERoutes.SESSION,
    exact: true,
    restricted: true,
    component: Pages.SessionPageComponent,
  },
  {
    path: ERoutes.HOME,
    exact: true,
    restricted: true,
    component: Pages.HomeComponent,
  },
  {
    path: ERoutes.LOGIN_ERROR,
    exact: true,
    restricted: true,
    component: Pages.LoginErrorComponent,
  },
  {
    path: ERoutes.EMAIL_NOT_VERIFIED,
    exact: true,
    restricted: false,
    component: Pages.EmailNotVerifiedComponent,
  },
  {
    path: ERoutes.WISH_FINDER,
    exact: true,
    restricted: true,
    component: Pages.WishFinderComponent,
  },
  {
    path: ERoutes.WISH_LIST_CATALOGUE,
    exact: true,
    restricted: true,
    component: Pages.WishListCatalogueComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.WISHLIST,
    },
  },
  {
    path: ERoutes.CONTACT_WISH_LIST_CATALOGUE,
    exact: true,
    restricted: true,
    component: Pages.WishListCatalogueComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_CONTACTS,
    },
  },
  {
    path: ERoutes.WISH_LIST,
    exact: true,
    restricted: true,
    component: Pages.WishListComponent,
  },
  {
    path: ERoutes.WISH_LIST_PUBLIC,
    exact: true,
    restricted: false,
    component: Pages.WishListComponent,
  },
  {
    path: ERoutes.CONTACT_WISH_LIST,
    exact: true,
    restricted: true,
    component: Pages.WishListComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_CONTACTS,
    },
  },
  {
    path: ERoutes.GROUP_LIST,
    exact: true,
    restricted: true,
    component: Pages.GroupListComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.NEW_GROUP,
    exact: true,
    restricted: true,
    component: Pages.WizardForm,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.EDIT_GROUP,
    exact: true,
    restricted: true,
    component: Pages.WizardForm,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.WISH,
    exact: true,
    restricted: true,
    component: Pages.NewWishFormComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.WISHLIST,
    },
  },
  {
    path: ERoutes.NEW_WISH,
    exact: true,
    restricted: true,
    component: Pages.NewWishFormComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.WISHLIST,
    },
  },
  {
    path: ERoutes.MY_CONTACT_LIST,
    exact: true,
    restricted: true,
    component: Pages.MyContactListComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_CONTACTS,
    },
  },
  {
    path: ERoutes.PERSONAL_PAGE,
    exact: true,
    restricted: true,
    component: Pages.PersonalPageComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.PERSONAL_PAGE,
    },
  },
  {
    path: ERoutes.GROUP,
    exact: true,
    restricted: true,
    component: Pages.ActiveGroupComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.GROUP_IN_PROGRESS_WISH,
    exact: true,
    restricted: true,
    component: Pages.GroupInProgressWishComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.GROUP_IN_PROGRESS_MONEYBOX,
    exact: true,
    restricted: true,
    component: Pages.GroupInProgressMoneyboxComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.CHAT,
    restricted: true,
    component: Pages.ChatComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.GROUPLIST,
    },
  },
  {
    path: ERoutes.MY_BANK,
    exact: true,
    restricted: true,
    component: Pages.MyBankComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_BANK,
    },
  },
  {
    path: ERoutes.PENDING_PAYMENTS,
    exact: true,
    restricted: true,
    component: Pages.PendingPaymentsComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_BANK,
    },
  },
  {
    path: ERoutes.PAYMENTS_RESUME,
    exact: true,
    restricted: true,
    component: Pages.PaymentsResumeComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_BANK,
    },
  },
  {
    path: ERoutes.SOCIAL_PROJECTS,
    exact: true,
    restricted: true,
    component: Pages.SocialProjectsComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_BANK,
    },
  },
  {
    path: ERoutes.LILI_BANK,
    exact: true,
    restricted: true,
    component: Pages.LiliSocialBankComponent,
    state: {
      [activeMenuItemKey]: EActiveMenuItem.MY_BANK,
    },
  },
  {
    path: ERoutes.POLICY,
    exact: true,
    restricted: true,
    component: Pages.PolicyPageComponent,
  },
  {
    path: ERoutes.TPV_OK,
    exact: false,
    restricted: false,
    component: Pages.OkKoComponent,
  },
  {
    path: ERoutes.TPV_KO,
    exact: false,
    restricted: false,
    component: Pages.OkKoComponent,
  },
  {
    path: ERoutes.ONBOARDING,
    exact: false,
    restricted: true,
    component: Pages.OnboardingComponent,
  },
  {
    path: ERoutes.EXPLORE,
    exact: true,
    restricted: false,
    component: Pages.ExploreComponent,
  },
  {
    path: ERoutes.NOT_FOUND,
    exact: true,
    restricted: false,
    component: Pages.NotFoundComponent,
  },
  {
    path: '*',
    restricted: false,
    component: Pages.NotFoundComponent,
  },
];
